import { NOTIFICATION_ROLES } from '../constants'

type NotificationMedium = 'overlayBanner' | 'toast' | 'snackbar' | 'pageBanner'

export interface NotificationMessage {
  title: string
  message: string
  medium: NotificationMedium
  role: string
}

export interface SavePropertyContext {
  /** When 'signup', the save happened right after account creation. */
  authType?: string | null
}

const NOTIFICATION_MESSAGES = {
  savePropertyConfirmation: (
    ctx?: SavePropertyContext
  ): NotificationMessage => ({
    title: `${
      ctx?.authType === 'signup' ? 'Thank you for signing up. ' : ''
    }Save Successful`,
    message:
      "You'll now receive updates on this property. View all your saved properties on your dashboard.",
    medium: 'overlayBanner',
    role: NOTIFICATION_ROLES.SUCCESS,
  }),

  unsaveProperty: (): NotificationMessage => ({
    title: 'Property Removed',
    message: 'The property is no longer saved on your dashboard.',
    medium: 'overlayBanner',
    role: NOTIFICATION_ROLES.SUCCESS,
  }),
} as const

export type NotificationMessageKey = keyof typeof NOTIFICATION_MESSAGES

export { NOTIFICATION_MESSAGES }
